@let blok = block();

<div class="my-4">
    <h3 class="font-bold text-left mb-2 text-xl">
        {{ blok.title }}
    </h3>
    <menu [attr.aria-label]="blok.title" class="ml-4">
        @for (child of blok.children; track child['_uid']) {
            <li [attr.aria-label]="child?.text">
                <s1-cms-component [blok]="child" />
            </li>
        }
    </menu>
</div>

